import { render } from "./VueImageVerify.vue?vue&type=template&id=015bbcfc"
import script from "./VueImageVerify.vue?vue&type=script&lang=js"
export * from "./VueImageVerify.vue?vue&type=script&lang=js"

import "./VueImageVerify.vue?vue&type=style&index=0&id=015bbcfc&lang=css"

import exportComponent from "E:\\vue-prj\\newbee-mall-vue3-app-main\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__